var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "install ko", attrs: { id: "wrap" } }, [
      _c("header", { staticClass: "p_header" }, [
        _c("section", { staticClass: "p_title" })
      ]),
      _vm._v(" "),
      _c("article", { staticClass: "tip_container" }, [
        _c("section", { staticClass: "section_tip1" }, [
          _c("div", { staticClass: "section_comment" }, [
            _c("p", [_vm._v("\n          확 바뀐 IKEN App!\n        ")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          더 잘 쓰게 만들어주는 꿀팁 대방출합니다.\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "tip_title" }, [
            _c("div", { staticClass: "tip_title_left" }, [
              _c("p", { staticClass: "tip_title_order" }, [
                _vm._v("\n            하나\n          ")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "tip_title_right" }, [
              _c("p", { staticClass: "tip_title_top" }, [
                _vm._v(
                  "\n            알아서 내가 자주 쓰는 서비스를 알려주네\n          "
                )
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "title_main" }, [
                _vm._v("\n            자동 추천 기능을 켜볼까?\n          ")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "tip_contents" }, [
            _c("p", [
              _vm._v("\n          내가 굳이 편집하지 않아도\n        ")
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          자주 사용했던 서비스 순서대로 보여요!\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          빠르게 내가 자주 쓰는 서비스로 이동하기 좋겠죠?\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "tip_info" }, [
            _c("div", { staticClass: "tip_flow" }, [
              _c("p", [_vm._v("자동추천 > 켜기")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "gradient" }),
            _vm._v(" "),
            _c("div", { staticClass: "tip_img" }, [
              _c("img", {
                staticClass: "img_phone",
                attrs: { src: require("@/assets/image/tip/phone-tip-01.png") }
              }),
              _vm._v(" "),
              _c("img", {
                staticClass: "img_detail",
                attrs: { src: require("@/assets/image/tip/main-3-x.png") }
              })
            ])
          ])
        ]),
        _vm._v(" "),
        _c("section", { staticClass: "section_tip2" }, [
          _c("div", { staticClass: "tip_title" }, [
            _c("div", { staticClass: "tip_title_left" }, [
              _c("p", { staticClass: "tip_title_order" }, [
                _vm._v("\n            둘\n          ")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "tip_title_right" }, [
              _c("p", { staticClass: "tip_title_top" }, [
                _vm._v(
                  "\n            내가 보고싶었던 정보가 다 모여 있네\n          "
                )
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "title_main" }, [
                _vm._v(
                  "\n            My를 메인 화면으로 바꿔 볼까?\n          "
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "tip_contents" }, [
            _c("p", [
              _vm._v(
                "\n          일정, 연차, 팀원근무현황, 구내식당이용정보\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          날씨, 대중교통 도착정보, 추천맛집 정보까지\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          앱을 켰을 때 바로 보고 싶으시다면 메인 화면으로 설정하세요!\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "tip_info" }, [
            _c("div", { staticClass: "tip_flow" }, [
              _c("p", [_vm._v("My를 메인으로 > 켜기")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "gradient" }),
            _vm._v(" "),
            _c("div", { staticClass: "tip_img" }, [
              _c("img", {
                staticClass: "img_phone",
                attrs: {
                  src: require("@/assets/image/tip/phone-01-copy-7.png")
                }
              }),
              _vm._v(" "),
              _c("img", {
                staticClass: "img_detail",
                attrs: { src: require("@/assets/image/tip/my-00-3-x.png") }
              })
            ])
          ])
        ]),
        _vm._v(" "),
        _c("section", { staticClass: "section_tip3" }, [
          _c("div", { staticClass: "tip_title" }, [
            _c("div", { staticClass: "tip_title_left" }, [
              _c("p", { staticClass: "tip_title_order" }, [
                _vm._v("\n            셋\n          ")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "tip_title_right" }, [
              _c("p", { staticClass: "tip_title_top" }, [
                _vm._v(
                  "\n            모바일로 바로 등록이 필요할 때\n          "
                )
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "title_main" }, [
                _vm._v("\n            등록 기능 바로 이동하기\n          ")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "tip_contents" }, [
            _c("p", [
              _vm._v(
                "\n          자원예약, 서비스 요청, 보안서비스 신청, 방문객예약\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("\n          +버튼을 누르면 바로 이동 가능해요~\n        ")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "tip_info" }, [
            _c("div", { staticClass: "tip_flow" }, [
              _c("p", [_vm._v("Work/News/My탭 > +버튼 선택")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "gradient" }),
            _vm._v(" "),
            _c("div", { staticClass: "tip_img" }, [
              _c("img", {
                staticClass: "img_phone",
                attrs: {
                  src: require("@/assets/image/tip/phone-01-copy-10.png")
                }
              })
            ])
          ])
        ]),
        _vm._v(" "),
        _c("section", { staticClass: "section_tip4" }, [
          _c("div", { staticClass: "tip_title" }, [
            _c("div", { staticClass: "tip_title_left" }, [
              _c("p", { staticClass: "tip_title_order" }, [
                _vm._v("\n            넷\n          ")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "tip_title_right" }, [
              _c("p", { staticClass: "tip_title_top" }, [
                _vm._v("\n            내가 관심있는 글만 쏙쏙\n          ")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "title_main" }, [
                _vm._v("\n            관심 키워드 등록 하기\n          ")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "tip_contents" }, [
            _c("p", [
              _vm._v("\n          평소에 관심있는 소식이 있나요?\n        ")
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          키워드를 등록해두면 키워드가 포함된 글이 등록되면\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("\n          따로 모아 볼 수 있어요!\n        ")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "tip_info" }, [
            _c("div", { staticClass: "tip_flow" }, [
              _c("p", [
                _vm._v("등록("),
                _c("img", {
                  attrs: {
                    src: require("@/assets/image/tip/icon-outlined-24-lg-1-menu-copy-4.png")
                  }
                }),
                _vm._v(")선택")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "gradient" }),
            _vm._v(" "),
            _c("div", { staticClass: "tip_img" }, [
              _c("img", {
                staticClass: "img_phone",
                attrs: {
                  src: require("@/assets/image/tip/phone-01-copy-8.png")
                }
              }),
              _vm._v(" "),
              _c("img", {
                staticClass: "img_detail",
                attrs: { src: require("@/assets/image/tip/my-09-3-x.png") }
              })
            ])
          ])
        ]),
        _vm._v(" "),
        _c("section", { staticClass: "section_tip5" }, [
          _c("div", { staticClass: "tip_title" }, [
            _c("div", { staticClass: "tip_title_left" }, [
              _c("p", { staticClass: "tip_title_order" }, [
                _vm._v("\n            다섯\n          ")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "tip_title_right" }, [
              _c("p", { staticClass: "tip_title_top" }, [
                _vm._v("\n            다양해진 알림 서비스\n          ")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "title_main" }, [
                _vm._v(
                  "\n            날씨 알림, 구내식당 메뉴 알림\n          "
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "tip_contents" }, [
            _c("p", [
              _vm._v(
                "\n          비/눈 오는 날은 우산 잊지 않도록 날씨 알림 서비스\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n          오늘의 구내식당 점심 메뉴를 알림으로 받아볼 수 있어요!\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "tip_info" }, [
            _c("div", { staticClass: "tip_flow" }, [
              _c("p", [_vm._v("1)날씨 알림 > 켜기")]),
              _vm._v(" "),
              _c("p", [_vm._v("2)구내식당 메뉴 알림 > 켜기")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "gradient" }),
            _vm._v(" "),
            _c("div", { staticClass: "tip_img" }, [
              _c("img", {
                staticClass: "img_phone",
                attrs: {
                  src: require("@/assets/image/tip/phone-01-copy-9.png")
                }
              })
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2999aa72", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2999aa72","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Tips.vue
// module id = null
// module chunks = 